module.exports = __webpack_public_path__ + "static/img/5.d073b22e.jpg";